import { Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '~/common/components/ui/button';
import { cn } from '~/common/utils/styleUtil';
import { TrackNavigationClick } from '~/tracking/TrackNavigationClick';

export interface NotificationsProps {
  onOpen: () => void;
  className?: string;
}

export function Notifications({ onOpen, className }: Readonly<NotificationsProps>) {
  const { t } = useTranslation();

  return (
    <TrackNavigationClick label={t('Mitteilungen')}>
      <Button
        variant="ghost"
        size={'sm'}
        className={cn('justify-start desktop:text-secondary mr-0 px-0 h-12 desktop:h-auto desktop:px-2', className)}
        data-testid={'notifications-button'}
        onClick={onOpen}
      >
        <Bell className={'w-[24px] h-[24px] desktop:w-[18px] desktop:h-[18px]'} />
        <div className={'ml-2 desktop:ml-1 text-base desktop:text-sm '}>{t('Mitteilungen')}</div>
      </Button>
    </TrackNavigationClick>
  );
}
